import { RouteConfig } from 'vue-router'

const routes: Array<RouteConfig> =  [
  {
    path: '/about',
    component: () => import('@/views/About/Index.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: false,
    }
  },
]

export default routes;